export default {
  init() {
    $("#export-relational-datas").click(function (e) {
      e.preventDefault();

      let button = $(this);

      $.ajax({
        url: ajaxurl,
        method: "POST",
        data: {
          action: $(this).data("action"),
          id: $(this).data("post-id"),
        },
        beforeSend: function () {
          button.text("File processing...");
        },
        success: function (data) {
          if (data.length) {
            let dataURL = arrayToCSV(data);
            window.location.href =
              "data:text/csv;charset=utf-8;base64," + btoa(dataURL);
          } else {
            alert("No datas to export");
          }
        },
        error: function (error) {
          console.error(error);
        },
        complete: function () {
          button.text("Download CSV");
        },
      });
    });
  },
  finalize() {
    $('[data-target="#modalEditCategory"]').on("click", function () {
      const categoryId = $(this).data("category-id");
      const categoryName = $(this).data("category-name");

      $('#modalEditCategory input[name="category_id"]').val(categoryId);
      $('#modalEditCategory input[name="category_name"]').val(categoryName);
    });

    $('[data-target="#modalDeleteCategory"]').on("click", function () {
      const categoryId = $(this).data("category-id");

      $('#modalDeleteCategory input[name="category_id"]').val(categoryId);
    });

    if ($("select#candidacy_job").val() == 0) {
      $("a#job-link").hide();
    } else {
      $("a#job-link").attr(
        "href",
        "http://localhost:9013/wp-admin/post.php?post=" +
          $("select#candidacy_job").val() +
          "&action=edit&lang=fr"
      );
    }

    $("select#candidacy_job").change(function () {
      if ($(this).val() == 0) {
        $("a#job-link").hide();
      } else {
        $("a#job-link")
          .show()
          .attr(
            "href",
            "http://localhost:9013/wp-admin/post.php?post=" +
              $(this).val() +
              "&action=edit&lang=fr"
          );
      }
    });
    $(".ct-filter-jobCategory").change(function () {
      var jobCategoryFilter = $(this).val();
      if (jobCategoryFilter != "") {
        document.location.href =
          "edit.php?post_type=jobs&page=candidacies" + jobCategoryFilter;
      }
    });

    $(".ct-filter-jobAvancement").change(function () {
      var jobAvancementFilter = $(this).val();
      if (jobAvancementFilter != "") {
        document.location.href =
          "edit.php?post_type=jobs&page=candidacies&jobAvancement-filter=" +
          jobAvancementFilter;
      }
    });

    $(".ct-filter-jobLanguage").change(function () {
      var jobLanguageFilter = $(this).val();
      if (jobLanguageFilter != "") {
        document.location.href =
          "edit.php?post_type=jobs&page=candidacies&jobLanguage-filter=" +
          jobLanguageFilter;
      }
    });

    $(".ct-filter-job").change(function () {
      var job = $(this).val();
      if (job != "") {
        document.location.href =
          "edit.php?post_type=jobs&page=candidacies&job-filter=" + job;
      }
    });

    $(".select_avancement").change(function () {
      var id = $(this).attr("id");
      var select_avancement = $(this).val();

      if (select_avancement != "" && id != "") {
        document.location.href =
          "edit.php?post_type=jobs&page=candidacies&action=update&id=" +
          id +
          "&data=" +
          select_avancement;
      }
    });

    if (window.location.href.search("page=candidacies") != -1) {
      let struc_table =
        '<tr id="tr-edit-box" class="inline-edit-row inline-edit-row-post bulk-edit-row bulk-edit-row-post bulk-edit-post inline-editor" style="display: none">' +
        '<td id="td-edit-box" class="colspanchange" colspan="8"></td></tr>';

      $(struc_table).insertAfter("thead");
      $("div#bulk-edit-box").appendTo("td#td-edit-box").show();

      $("#bulk-action-selector-top").change(function () {
        if ($(this).val() == "bulk-edit") {
          $("tr#tr-edit-box").show();
        } else {
          $("tr#tr-edit-box").hide();
        }
      });

      $("button.cancel").click(function () {
        $("tr#tr-edit-box").hide();
        $("#bulk-action-selector-top").val(-1);
      });

      function bulk_box() {
        $("div.bulk-line").each(function () {
          $(this)
            .find(".ntdelbutton")
            .click(function () {
              $(this).parent().remove();
              let id = $(this).parent().attr("id").substr(5);
              $("input[value=" + id + "][name=bulk-delete]").prop(
                "checked",
                false
              );
            });
        });
      }

      bulk_box();

      $("input[name=bulk-delete]").change(function () {
        let struc_item_bulk =
          '<div class="bulk-line"><a class="ntdelbutton" title="Remove From Bulk Edit">X</a></div>';
        let id = $(this).val();

        if ($(this).is(":checked")) {
          $(struc_item_bulk)
            .appendTo("div#bulk-titles")
            .attr("id", "line-" + id);
          let parent = $(this).parent().parent();
          let firstname = $(parent).find("td.column-firstname").text();
          let lastname = $(parent).find("td.column-lastname").text();
          $("div#line-" + id).append(firstname + " " + lastname);
          bulk_box();
        } else {
          $("div.bulk-line[id=line-" + id + "]").remove();
        }
      });
    }

    $("#bulk_edit_submit").click(function () {
      var ids = [];
      var params = [];

      $(".bulk-line").each(function () {
        ids.push($(this).attr("id").substr(5));
      });

      $(".select-bulk-edit").each(function () {
        if ($(this).val() != "") {
          params[$(this).attr("name")] = $(this).val();
        }
      });

      params["ids"] = ids;

      var redirect = "edit.php?post_type=jobs&page=candidacies&action=update";

      for (var index in params) {
        redirect += "&" + index + "=" + params[index];
      }

      redirect = redirect.replace(/,/g, "-");

      document.location.href = redirect;
    });

    if (window.location.href.search("taxonomy=candidacies_status") != -1) {
      $("a:contains('Status')").parent().addClass("current");
    }
  },
};

function arrayToCSV(objArray) {
  const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  let str =
    `${Object.keys(array[0])
      .map((value) => `"${value}"`)
      .join(",")}` + "\r\n";

  return array.reduce((str, next) => {
    str +=
      `${Object.values(next)
        .map((value) => `"${value}"`)
        .join(",")}` + "\r\n";
    return str;
  }, str);
}
